import { useEffect, useState } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../theme/Component/ListMenu";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicTable } from "../../theme/Component/BasicTable";
import { Modal } from "../../theme/Component/Modal";
import { SelectAccountantTree } from "../../contabilidad/catalogo-cuentas/AccountantTree/SelectAccountantTree";
import { SelectBudgetID } from "../../admin/configuracion/BudgetID/SelectBudgetID";
import { BasicSwitch } from "../../theme/Component/BasicSwitch";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { _WelfareEntity } from "../../../core/services/dataBean/EntityCatalogVdos";
import { WelfareEntityTypeConstantsSelector } from "../ParametrosTalentoHumano/ImportedPayrollBeneficiary/WelfareEntityTypeConstants";
import { WelfareEntityTypeEditor } from "../ParametrosTalentoHumano/EmployeeBonus/Editors/WelfareEntityType.Editor";
import { BasicButton } from "../../theme/Component/BasicButton";
import usePaginator from "../../theme/Component/usePaginator";
import { AccountEditor } from "../../editor/AccountEditor";
import { WelfarePaymentConstants } from "./WelfarePaymentConstants";
import { SelectSiteID } from "../../admin/configuracion/SiteID/SelectSiteID";
import { WelfareEntityincapacities } from "../ParametrosTalentoHumano/ImportedPayrollBeneficiary/WelfareEntityincapacities";
import { DropDown } from "../../theme/Component/DropDown";
import { ExportXLSL } from "../../theme/Component/ExportXLSX";
import useModal, { MODAL_md, MODAL_SM } from "../../theme/Component/hooks/useModal";
import { FileInput } from "../../theme/Component/FileInput";
import { _DaoInfo, _single } from "../../../core/services/dataBean/EntityCatalog";
import { ExportHeadersXLSX } from "../../theme/Component/ExcelsComponents/ExportHeadersXLSX";



export const WelfareEntity = () => {

    const { instance, bean, setBean, lista, setLista, update, deleteItemVoid, handleChange } = useDataBean(_WelfareEntity);
    const { instance: instanceDao } = useDataBean(_DaoInfo);
    const paginador = usePaginator();

    const [contanst, setconstansts] = useState<any>(null)
    const [tipe, settipe] = useState<any>(null)
    const [regexStr, setregexStr] = useState<any>(null)
    const [arrayName, setArrayName] = useState<string[]>([]);

    const [listaExport, setListaExport] = useState([]);

    const [file, setFile] = useState<any>({});

    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const modalCSV = useModal("Reporte", MODAL_SM);
    const modalImport = useModal("Importar Entidades", MODAL_md);
    const modalDocImport = useModal("Documento de Importación", MODAL_SM);


    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {

        instance.getWelfareEntityCatalogByType(contanst, tipe, regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)

                    setLista(resp.List)
                }
            }
        ).catch(err => { toast.error(err) })

    }

    const getListaExport = () => {
        instance.getWelfareEntityCatalogByType(contanst, tipe, regexStr, 1, paginador.pages * 15).then(
            (resp) => {
                modalCSV.open();
                setListaExport(resp.List)
            }
        ).catch(
            err => {
                console.log(err)
                toast.error("No se pudo realizar la consulta")
            }
        )
    }

    const create = () => {
        setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        deleteItemVoid(bean.IDWelfareEntity).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const importarItem = () => {
        instance.importWelfareEntity(_single.getAccountID(), file.Media, file.MediaContext).then(
            (resp) => {
                // if(resp?.Summary?.Success){
                //     toast.success(`Se modificaron/crearon ${resp?.Summary?.Success}`)
                // }else if (resp?.Summary?.Errors){
                //     toast.error(`No se pudieron crear/modificar ${resp?.Summary?.Success} registros`)
                // }
                getLista();
                modalImport.close();
            }
        ).catch(err => { toast.error(err) })
    }

    const head = [
        { title: 'ID', property: 'IDWelfareEntity', visible: true },
        { title: 'Código', property: 'Code', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Tipo', property: 'TypeName', visible: true },
        { title: 'Tipo de Entidad', property: 'WelfareEntityTypeName', visible: true },
        { title: 'Tercero', property: 'AccountName', visible: true },
        { title: 'Utiliza Presupuesto', property: 'ApplyBudget', visible: true },
        { title: 'Rubro Presupuestal', property: 'BudgetName', visible: true },
        { title: 'Utilizar Cuenta Contable', property: 'AccountantIDStrName', visible: true },
        { title: 'Frecuencia de Pago', property: 'PaymentFrecuency', visible: true },
        { title: 'Fabrica de Reportador', property: 'ClassFileFactory', visible: true },
        { title: 'Ubicación Geográfica', property: 'SiteIDName', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const actionsDropDown = [
        { id: 1, name: 'Descargar Detallado', permiso: null, activo: true },
        { id: 2, name: 'Importar Entidades', permiso: null, activo: _single.canExport() },
        { id: 3, name: 'Descargar Formato de Importación', permiso: null, activo: _single.canExport() },
    ];

    const getExcelExport = () => {
        instanceDao.exportExcelTemplate("admin.WelfareEntity").then(
            (resp) => {
                console.log(resp.Headers)
                if(resp.Headers.length>0){
                    setArrayName(resp.Headers);
                    modalDocImport.open();
                }else {
                    toast.error("sin configruacion")
                }
            }
        ).catch(err => { toast.error(err) })
    }

    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    {_single.canExport() &&
                        <DropDown lista={actionsDropDown} eventClick={actions}></DropDown>
                    }

                </div>
            </div>
        )
    }

    const actions = (e: any) => {
        if (e.id === 1) {
            getListaExport();
        } else if (e.id === 2) {
            modalImport.open()
        } else if (e.id === 3) {
            getExcelExport();
        }
    }

    return (
        <BasicPage titulo="Entidades de Seguridad Social">
            <div className="row">
                <div className="col-md-4">
                    <WelfareEntityTypeConstantsSelector label='Tipo' idSelector={contanst} onChange={(e) => { setconstansts(e) }} />
                </div>

                <div className="col-md-4">
                    <WelfareEntityTypeEditor idSelector={tipe} onChange={(e) => { settipe(e) }} label="Tipo de Entidad" />
                </div>

                <div className="col-md-4">
                    <label>Búsqueda por Texto</label>
                    <input type="text" name="regexStr" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                </div>

                <div className="col-md-4">
                    <BasicButton value="Buscar por Filtros*" icon="ri-file-add-line" eventClick={getLista} ></BasicButton>
                </div>


                <div className="col-md-12">
                    <BasicTable headButtons={buttons()} body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} records={paginador} />
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">

                            <div className="col-md-6">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={bean.Name} onChange={handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Codígo</label>
                                <input type="text" name="Code" className="form-control" value={bean.Code} onChange={handleChange} />
                            </div>
                            <div className="col-md-6">
                                <WelfareEntityTypeConstantsSelector label='Tipo' idSelector={bean.Type} onChange={(e) => { setBean({ ...bean, "Type": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <WelfareEntityTypeEditor idSelector={bean.IDWelfareEntityType} onChange={(e) => { setBean({ ...bean, "IDWelfareEntityType": e }) }} label="Tipo de Entidad" />
                            </div>
                            <div className="col-md-6">
                                <AccountEditor label="Tercero" idAccount={bean.IDAccount} onChange={(e) => { setBean({ ...bean, "IDAccount": e.IDAccount }) }}></AccountEditor>
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label='Utiliza presupuesto' estado={bean.ApplyBudget} eventChange={(e) => { setBean({ ...bean, "ApplyBudget": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectBudgetID label="Rubro Presupuestal" edit={false} tipoPresupuesto={null} jsonCode={bean.IDBudget} onChange={(e) => { setBean({ ...bean, "IDBudget": e.JsonCode }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectAccountantTree label="Utilizar Cuenta Contable" jsonCode={bean.AccountantID} onChange={(e) => { setBean({ ...bean, "AccountantID": e.AccountantID, "AccountantIDStr": e.JsonCode }) }} />
                            </div>

                            <div className="col-md-6">
                                <WelfarePaymentConstants label='Frecuencia de Pago' idSelector={bean.PaymentFrecuency} onChange={(e) => { setBean({ ...bean, "PaymentFrecuency": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Fabrica de Reportador</label>
                                <input type="text" name="ClassFileFactory" className="form-control" value={bean.ClassFileFactory} onChange={handleChange} />
                            </div>
                            <div className="col-md-6">
                                <SelectSiteID label='Ubicación Geográfica' edit={false} idLnSite={bean.IDSite} onChange={(e: any) => { setBean({ ...bean, "IDSite": e.IDLn }); }} />
                            </div>
                        </div>
                    </Modal>

                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {bean.Name}</strong>
                    </ModalConfirm>

                    <Modal modal={modalCSV.modal} updateModal={modalCSV.setModal}>
                        <div className="row">
                            <div className="col">
                                {lista.length > 0 &&
                                    <ExportXLSL customName={"EntidadesSS"} optionIcon="ri-download-cloud-2-line text-success" title={head} data={listaExport} onExport={(name: string) => {
                                        _single.download("formato xlsx [" + name + "] con " + lista.length + " registros");
                                    }} />
                                }
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalImport.modal} updateModal={modalImport.setModal} eventModal={importarItem} onSubmitLabel="Importar">
                        <div className="row">
                            <div className="col-md-12">
                                <FileInput directory="temp" onCreate={setFile} />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalDocImport.modal} updateModal={modalDocImport.setModal}>
                        <div className="row">
                            <ExportHeadersXLSX headers={arrayName} customName="entidadesSS" onExport={(name: string) => { _single.download("formato de importacion xlsx [" + name + "]"); }} />
                        </div>
                    </Modal>
                </div>

            </div>
        </BasicPage>
    )
}